import _typeof from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import cards from "@/components/overview/common/cards/card";
import KivaProxy from "@/utils/kivaProxy/src/index";
import { CrmAccountTransformer } from "@/transformers/CrmAccountTransformer";
import KvNoteList from "@/components/global/kvNoteList";
import Activities from "@/components/tasks/activities/list";
import Attachments from "@/components/tasks/main/attachments";
import meetingsAccountForm from "@/components/tasks/activities/meetingsAccountForm";
import Email from "@/components/tasks/rightDrawer/views/email";
import AccountForm from "@/views/crm/components/account/form";
import Project from "@/views/crm/components/account/projects";
import Contacts from "@/views/crm/components/account/contacts";
import Deals from "@/views/crm/components/account/deals";
import Tasks from "@/views/crm/components/account/tasks";
import { DataQuery1 } from "@/transformers/DataQuery1";
import activitiesMixin from "@/mixins/task/activities";
import SvgIcon from "@/components/kiva/kvSvgIcon.vue";
import { Base64 } from "js-base64";
import optionsMixin from "@/mixins/options";
export default {
  name: "CrmAccountDetail",
  mixins: [activitiesMixin, optionsMixin],
  components: {
    cards: cards,
    KvNoteList: KvNoteList,
    Attachments: Attachments,
    Activities: Activities,
    Email: Email,
    Deals: Deals,
    AccountForm: AccountForm,
    Contacts: Contacts,
    Tasks: Tasks,
    meetingsAccountForm: meetingsAccountForm,
    kvWorking: function kvWorking() {
      return import("@/components/kiva/static/kvWorking");
    },
    SvgIcon: SvgIcon,
    Project: Project
  },
  computed: {
    accountId: function accountId() {
      return this.$route.params.id;
    },
    toggleSidebar: function toggleSidebar() {
      return this.$store.state.app.secondSidebar;
    }
  },
  data: function data() {
    return {
      account: {},
      account_key: "account_key",
      rightSideBar: "contacts",
      selectedEventKey: "selectedEventKey",
      searchContactText: "",
      selectedEvent: {},
      emailSender: {
        to: ""
      },
      open: {
        contact: false,
        deals: false,
        project: false,
        task: false,
        files: false
      },
      data: {
        contact: {
          total: 0,
          data: [],
          type: "light",
          path: "/crm/contacts"
        },
        deals: {
          total: 0,
          data: [],
          type: "light",
          path: "/crm/deals/table"
        },
        project: {
          total: 0,
          data: [],
          type: "light",
          path: "/dashboard/projectPortfolio"
        },
        task: {
          total: 0,
          data: [],
          type: "light",
          path: "/tasks"
        },
        files: {
          showUploadField: false,
          total: 0,
          data: [],
          type: "light",
          path: "/documents"
        }
      },
      attachmentsList: [],
      loading: false,
      focusSubject: false,
      editTitle: false,
      editStatus: false,
      saveDirect: false,
      hideIfNotFull: false,
      query: [],
      accountTypes: [],
      activeTabsValue: "1",
      cardPhotoKey: "cardPhotoKey"
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.getData();
            _context.next = 3;
            return _this.getOptions({
              app: "crm",
              model: "account",
              column: "account_type"
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    goPath: function goPath(section) {
      this.$router.push({
        path: this.data[section].path,
        query: {
          search: Base64.encode(JSON.stringify({
            accountName: {
              value: 527,
              label: "deneme şirketi"
            }
          }))
        }
      });
    },
    selectContact: function selectContact(id) {
      // this.$store.state.app.templatePopup.data = {record_id: id,model:'contact',openSearchBox:false};
      // this.$store.state.app.templatePopup.show = true;
      this.$store.dispatch("app/activateDrawer", {
        show: true,
        tab: "contact",
        options: {
          accountName: {
            value: this.account.recordId,
            label: this.account.accountName
          }
        }
      });
    },
    selectDeal: function selectDeal(id) {
      this.$store.state.app.templatePopup.data = {
        record_id: id,
        model: "deal",
        openSearchBox: false,
        force: {
          accountName: {
            value: this.account.recordId,
            label: this.account.accountName
          }
        }
      };
      this.$store.state.app.templatePopup.show = true;
    },
    selectTask: function selectTask(id) {
      this.$store.state.tasks.popup.task = {
        record_id: id
      };
      this.$store.state.tasks.popup.show = true;
    },
    selectProject: function selectProject(id) {
      this.$store.state.app.templatePopup.data = {
        record_id: id,
        model: "project",
        openSearchBox: false
      };
      this.$store.state.app.templatePopup.show = true;
    },
    selectFile: function selectFile() {
      this.data.files.showUploadField = !this.data.files.showUploadField;
    },
    toggleSection: function toggleSection(content) {
      this.open[content] = !this.open[content];
      if (this.data[content].type == "full") {
        this.hideIfNotFull = false;
      }
      this.data[content].type = "light";
    },
    openDetail: function openDetail(content) {
      this.open[content] = true;
      this.hideIfNotFull = true;
      this.data[content].type = "full";
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.account.logo = URL.createObjectURL(file.raw);
    },
    saveFormData: function saveFormData(e) {
      var _this2 = this;
      var $fileInput = this.$refs.upload;
      var formData = new FormData();
      if ($fileInput.uploadFiles.length) {
        formData.append("file", $fileInput.uploadFiles[0].raw, $fileInput.uploadFiles[0].name);
      }
      var endpoint = "data/crm/account/".concat(this.account.recordId, "/logo/content");
      new KivaProxy({
        endpoint: endpoint,
        driver: "base"
      }).submit("post", endpoint, formData)
      // .update(formData)
      .then(function (response) {
        new KivaProxy({
          endpoint: "crm/account"
        }).setFields(["logo"]).find(_this2.accountId).then(function (response) {
          // console.log(response)
          _this2.account.logo = response.record.logo;
          _this2.loading = false;
          _this2.cardPhotoKey = "cPK" + Math.random(0, 999999);
        });
      });
    },
    setEvent: function setEvent(event) {
      if (event && _typeof(event) == "object") {
        if (event.name == "email") {
          this.emailSender.to = event.to;
          this.activeTabsValue = "2";
        }
      }
    },
    getData: function getData() {
      var _this3 = this;
      this.loading = true;
      new KivaProxy({
        endpoint: "crm/account"
      }).setFields(["account_name", "account_type", "industry", "logo", "phone", "website", "commercial_title", "tax_code", "tax_area", "billing_country", "state", "billing_city", "billing_town", "billing_address", "billing_zipcode", "billing_location", "record_id", "support_followers", "support_owner", "sla_level", "sla"]).find(this.accountId).then(function (response) {
        // console.log(response)
        _this3.account = CrmAccountTransformer.fetch(response.record);
        _this3.loading = false;
        _this3.getQuery();
      }).catch(function (err) {
        console.log("err", err);
      });
    },
    getQuery: function getQuery() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var filter;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              filter = {
                crm_account_id: ["=", _this4.account.record_id]
              };
              _context2.next = 3;
              return new KivaProxy({
                endpoint: "kvc/data/query/8",
                driver: "base"
              }).setFilters(filter).all().then(function (response) {
                _this4.loading = false;
                _this4.total = response.total;
                _this4.query = response.data[0];
              }).catch(function (err) {
                console.log("err", err);
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleTabClick: function handleTabClick(tab, event) {}
  },
  watch: {
    accountId: function accountId(val) {
      this.getData();
      this.account_key = "m" + Math.random(99, 9999);
    },
    editTitle: function editTitle(val) {
      var _this5 = this;
      if (val) {
        setTimeout(function () {
          _this5.$refs.editTitle.$el.getElementsByTagName("input")[0].focus();
        }, 300);
      }
    }
  }
};